import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

// Renders editable FAQ/accordion sections above the footer. SEO-friendly (content is in the DOM).
export function FaqAccordion({ sections }) {
  if (!sections || sections.length === 0) return null;
  return (
    <section className="border-t border-border bg-muted/30" data-testid="faq-accordion">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
        <h2 className="font-heading text-2xl sm:text-3xl font-black tracking-tight mb-6">
          Preguntas frecuentes
        </h2>
        <Accordion type="single" collapsible className="w-full">
          {sections.map((s, i) => (
            <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`} className="border-border">
              <AccordionTrigger className="text-left font-heading font-bold hover:no-underline">
                {s.q}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground leading-relaxed whitespace-pre-wrap">
                {s.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
